import isPendingToConnectKeplr from './atom';

export default isPendingToConnectKeplr;
